import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';

@Component({
  selector: 'admin-create-user',
  templateUrl: './users.component.html',
})
export class AdminCreateUserComponent implements OnInit {
  public userForm: FormGroup;
  public result: string;

  constructor(private http: HttpClient, private fb: FormBuilder) {

    this.userForm = fb.group({
      Email: new FormControl(`elubin1234+zzz${Math.floor(Math.random() * (90000) + 10000)}@gmail.com`),
      FirstName: new FormControl(''),
      LastName: new FormControl(''),
      // random phone number
      PhoneNumber: new FormControl(`561-${Math.floor(Math.random() * (900) + 100)}-${Math.floor(Math.random() * (9000) + 1000)}`)
    });
  }
  ngOnInit() {
  }

  public doit(evt) {
    this.http.post(`/admin/AddUser`, this.userForm.value).subscribe(
      (resp: { result: string }) => {
        console.log(resp);
        this.result = resp.result;
        if (resp.result) {
          this.userForm.controls.Email.setValue(`elubin1234+zzz${Math.floor(Math.random() * (90000) + 10000)}@gmail.com`);
          this.userForm.controls.PhoneNumber.setValue(`561-${Math.floor(Math.random() * (900) + 100)}-${Math.floor(Math.random() * (9000) + 1000)}`);
          this.userForm.controls.FirstName.setValue('');
          this.userForm.controls.LastName.setValue('');
        }
      },
      (err) => console.error(err)
    )
  }

}
